import type {MySongsPageReducer} from "../../mySongsPage.types";

export interface IFilterDifficultyIdReducerPayload {
  difficultyId: number;
  difficultyCategory: {
    difficultyCategoryId: number;
    difficultyIds: number[];
  };
}

export const selectFilterDifficultyIdCaseReducer: MySongsPageReducer<IFilterDifficultyIdReducerPayload> = (store, action) => {
  const {difficultyId, difficultyCategory: {difficultyCategoryId, difficultyIds}} = action.payload;

  const difficulties = Array.from<number>(
    (new Set<number>([
      ...(store.difficulty?.difficulties ?? []),
      difficultyId,
    ]))
      .values()
  );

  const uniqueCategoryDifficultyIds = Array.from<number>(
    (new Set<number>(difficultyIds))
      .values()
  );

  const difficultyIdsFromCategorySelected = difficulties
    .filter((value) => difficultyIds.includes(value));

  const isAllCategoryDifficultyIdsSelected: boolean = (
    // action difficultyId is a part of category difficultyIds
    difficultyIds.includes(difficultyId)
    //
    && difficultyIdsFromCategorySelected.length === uniqueCategoryDifficultyIds.length
  );

  const difficultyCategories = [ ...(store.difficulty?.difficultyCategories ?? []), ];

  if (isAllCategoryDifficultyIdsSelected) {
    // all difficultyIds under category are selected, mark category as selected
    difficultyCategories.push(difficultyCategoryId);
  }

  return {
    ...store,
    difficulty: {
      ...store.difficulty,
      difficulties,
      difficultyCategories,
    },
  };

}
export const unselectFilterDifficultyIdReducer: MySongsPageReducer<IFilterDifficultyIdReducerPayload> = (store, action) => {
  const {difficultyId, difficultyCategory: {difficultyCategoryId}} = action.payload;

  const difficultyCategories = [...(store.difficulty?.difficultyCategories ?? []),]
    .filter((storeDifficultyCategoryId) => storeDifficultyCategoryId !== difficultyCategoryId);

  const difficulties = [...(store.difficulty?.difficulties ?? []),]
    .filter((storeDifficultyId) => difficultyId !== storeDifficultyId);

  return {
    ...store,
    difficulty: {
      ...store.difficulty,
      difficulties,
      difficultyCategories,
    },
  };
}
